export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_REGISTRATION = 'AUTH_REGISTRATION'
export const AUTH_FORGOT_PASSWORD = 'AUTH_FORGOT_PASSWORD'
export const AUTH_RESET_PASSWORD = 'AUTH_RESET_PASSWORD'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_STATUS = 'AUTH_STATUS'
export const AUTH_STATUS_END = 'AUTH_STATUS_END'
export const AUTH_CHECK = 'AUTH_CHECK'
export const AUTH_HEADER = 'AUTH_HEADER'


export const ADD_ITEM_TO_STORE = 'ADD_ITEM_TO_STORE'
export const ADD_OPTIMIZATION_ITEMS_TO_STORE = 'ADD_OPTIMIZATION_ITEMS_TO_STORE'
export const REMOVE_ALL_ITEMS_FROM_STORE = 'REMOVE_ALL_ITEMS_FROM_STORE'
export const REMOVE_ITEM_FROM_STORE = 'REMOVE_ITEM_FROM_STORE'


export const MODEL_DIMENSIONS = 'MODEL_DIMENSIONS'

export const EXPAND_LEFT_NAVIGATION = 'EXPAND_LEFT_NAVIGATION'
export const SHOW_GLOBAL_ALERT = 'SHOW_GLOBAL_ALERT'
export const SHOW_GLOBAL_LOADER = 'SHOW_GLOBAL_LOADER'
